export const LOCALIZACAO_UNIDADES_TOGGLE_LOADING =
  'LOCALIZACAO_UNIDADES_TOGGLE_LOADING'
export const LOCALIZACAO_UNIDADES_FETCH_LOCATIONS =
  'LOCALIZACAO_UNIDADES_FETCH_LOCATIONS'



// WEBPACK FOOTER //
// ./src/store/modules/localizacao_unidades/types.js